module.exports = __webpack_public_path__ + "static/images/containers/Challenges/images/top-shadows-tile.8f0110f3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/images/top-shadows-tile.png
// module id = 2874
// module chunks = 11